import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Router from "../routes/Routers";
import "../assets/styles/local/sidebars.css";

import { ReactComponent as BookeepingIcon } from "../assets/navigation/Nav-Bookkeeping.svg";
import { ReactComponent as ContactsIcon } from "../assets/navigation/Nav-Contacts.svg";
import { ReactComponent as CoWorkerIcon } from "../assets/navigation/Nav-Coworker.svg";
import { ReactComponent as PayrollIcon } from "../assets/navigation/Nav-Payroll.svg";
import { ReactComponent as FacebookIcon } from "../assets/navigation/Nav-Facebook.svg";
import { ReactComponent as ProjectIcon } from "../assets/navigation/Nav-Projects.svg";
import { ReactComponent as QuotesIcon } from "../assets/navigation/Nav-Quotes.svg";
import { ReactComponent as SettingIcon } from "../assets/navigation/Nav-Settings.svg";
import { ReactComponent as StockIcon } from "../assets/navigation/Nav-Stock.svg";
import { ReactComponent as TaskIcon } from "../assets/navigation/Nav-Tasks.svg";
import { ReactComponent as WorktimeIcon } from "../assets/navigation/Nav-Worktime.svg";
import { ReactComponent as EquipmentIcon } from "../assets/navigation/Nav-Equipment.svg";
import { ReactComponent as DashboardIcon } from "../assets/navigation/Nav-Dashboard.svg";
import { ReactComponent as OCRIcon } from "../assets/navigation/Nav-OCR.svg";
import { ReactComponent as ResourcesGridIcon } from "../assets/navigation/Nav-ResourcesGrid.svg";
import { ReactComponent as InvoiceBlackIcon } from "../assets/navigation/Nav-InvoiceBlack.svg";
import { ReactComponent as AssetIcon } from "../assets/navigation/Nav-AssetIcon.svg";
import { ReactComponent as CommercialIcon } from "../assets/navigation/Nav-CommercialIcon.svg";
import { ReactComponent as AIicon } from "../assets/navigation/Nav-AIicon.svg";

import {
  AiFillCaretDown,
  AiFillCaretUp,
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { BsArrowLeftCircle, BsArrowRightCircle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
  Bookkeeping_Props,
  getAppSideBarOptions,
} from "../redux/actions/action";
import { fetchScreenTranslations } from "../utils/helpers/translations";
import { ROLES, isRole } from "../utils/helpers/userRole";

const Sidebar = () => {
  const dispatch = useDispatch();
  const roleAccess = window.localStorage.getItem("roleid");
  const packageId = window.localStorage.getItem("packageId");

  const [isPlusMember, setIsPlusMember] = useState(false);
  const [isBasicMember, setIsBasicMember] = useState(false);
  const location = useLocation();
  const [fetchTranslationDatas, setFetchTranslationDatas] = useState({});
  const [isSideNavOpen, setSideNavOpen] = React.useState(true);
  const history = useHistory();
  const FetchCompanyThemRes = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const [packageID, setPackageID] = useState("");

  useEffect(() => {
    if (getAppSideNavOptions.status === true)
      setPackageID(getAppSideNavOptions?.[0]?.packageId);
    localStorage.setItem("packageName", getAppSideNavOptions[0]?.packageName);
    localStorage.setItem("packageId", getAppSideNavOptions[0]?.packageId);
  }, [getAppSideNavOptions]);

  // new solution redirect start
  const [openMenu, setOpenMenu] = useState(null);

  const handleParentClick = (item) => {
    console.log("asc71", item);

    // Toggle submenu open
    if (openMenu === item.identifier) {
      setOpenMenu(null); // close if already open
    } else {
      setOpenMenu(item.identifier); // open submenu
    }

    // Redirect to planboard if it's Collaborate
    if (item.identifier === "TEAMCONNECT") {
      if (
        getAppSideNavOptions?.[0]?.packageId ===
        process.env.REACT_APP_IS_SPIRE_LITE
      ) {
        history.push("/todolist");
      } else {
        history.push("/planboard");
      }
    }
    if (item.identifier === "ASSETS") {
      history.push("/asset-management");
    }
    if (item.identifier === "COWORKERS") {
      history.push("/member-list");
    }
    if (item.identifier === "CONTACTS") {
      history.push("/company-list");
    }
    if (item.identifier === "PROJECT_PARFORMA") {
      history.push("/proforma");
    }
    if (item.identifier === "STOCK") {
      history.push("/productsList");
    }
  };
  // new solution redirect end

  // new sideBar start
  const _SideNavOptions = [
    {
      identifier: "SpireGPT",
      position: 0,
      url: () => "chat",
      icon: <ProjectIcon className="app-nav-icon" />,
      activeTags: ["SpireGPT"],
      label: "Spire GPT",
      translationFieldName: "Spire GPT",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
    },

    {
      identifier: "TEAMCONNECT",
      position: 1,
      url: () => "planboard",
      icon: <CoWorkerIcon className="app-nav-icon" />,
      activeTags: ["planboard", "teamconnect"],
      label: "Collaborate",
      translationFieldName: "Plan Board",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "To Do List",
          label: "To Do List",
          activeTags: ["To Do List"],
          url: () => "todolist",
          translationFieldName: "To Do List",
          hide: () => false,
        },

        {
          identifier: "PLANBOARD",
          label: "Plan Board",
          activeTags: ["planboard"],
          url: () => "planboard",
          translationFieldName: "Plan Board",
          hide: () => false,
        },

        {
          identifier: "TEAMCONNECT",
          label: "Team Connect",
          activeTags: ["teamconnect"],
          url: () => "teamconnect",
          translationFieldName: "TeamConnect",
          hide: () => false,
          mobileOnly: false,
          bottom: false,
        },
      ],
    },

    {
      identifier: "PROJECT",
      position: 2,
      url: () => "project",
      icon: <ProjectIcon className="app-nav-icon" />,
      activeTags: ["project"],
      label: "Project",
      translationFieldName: "Projects",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
    },

    {
      identifier: "ASSETS",
      position: 3,
      url: () => "asset-management",
      icon: <AssetIcon className="app-nav-icon" />,
      activeTags: ["assets", "asset-management", "work-orders"],
      label: "Assets",
      translationFieldName: "Asset",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "ASSETS",
          label: "List",
          activeTags: "",
          url: () => "asset-management",
          translationFieldName: "List",
          hide: () => false,
        },

        {
          identifier: "ASSETS",
          label: "Work Orders",
          activeTags: "",
          url: () => "work-orders",
          translationFieldName: "Work Orders",
          hide: () => false,
        },
      ],
    },

    {
      identifier: "COWORKERS",
      position: 4,
      url: () => "member-list",
      icon: <ResourcesGridIcon className="app-nav-icon" />,
      activeTags: ["member-list", "worktime"],
      label: "Resources",
      translationFieldName: "Resources",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "COWORKERS",
          label: "Co-Workers",
          activeTags: ["member-list"],
          url: () => "member-list",
          translationFieldName: "Co-Workers",
          hide: () => false,
        },

        {
          identifier: "WORKTIME",
          label: "Worktime",
          activeTags: ["worktime"],
          url: () => "worktime",
          translationFieldName: "Worktime",
          hide: () =>
            window.localStorage.getItem("companyid") ==
              "28830f30-b321-4662-a576-f23451677742" ||
            window.localStorage.getItem("hasPlus") == "true",
        },
        // {
        //   identifier: "WORKTIME",
        //   label: "PO Hiring",
        //   activeTags: ["worktime"],
        //   url: () => "worktime",
        //   translationFieldName: "PO Hiring",
        //   hide: () => false,
        // },
      ],
    },

    {
      identifier: "STOCK",
      position: 5,
      url: () => "stock",
      icon: <StockIcon className="app-nav-icon" />,
      activeTags: ["stock"],
      label: "Inventory",
      translationFieldName: "Inventory",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "Products & Services",
          label: "Products & Services",
          activeTags: ["productsList"],
          url: () => "productsList",
          translationFieldName: "Products & Services",
          hide: () => false,
        },

        {
          identifier: "Stock Levels",
          label: "Stock Levels",
          activeTags: ["Stock Levels"],
          url: () => "stock",
          translationFieldName: "Stock Levels",
          hide: () => false,
        },

        {
          identifier: "PO Materials",
          label: "PO Materials",
          activeTags: ["stock-materials"],
          url: () => "stock-materials",
          translationFieldName: "PO Materials",
          hide: () => false,
        },

        {
          identifier: "Add to Warehouse",
          label: "Add to Warehouse",
          activeTags: ["add-to-warehouse-project"],
          url: () => "add-to-warehouse-project",
          translationFieldName: "Add to Warehouse",
          hide: () => false,
        },

        {
          identifier: "Order Picking",
          label: "Order Picking",
          activeTags: ["order-picking"],
          url: () => "order-picking",
          translationFieldName: "Order Picking",
          hide: () => false,
        },

        {
          identifier: "Return Warehouse",
          label: "Return Warehouse",
          activeTags: ["return-to-warehouse-single"],
          url: () => "return-to-warehouse-single",
          translationFieldName: "Return Warehouse",
          hide: () => false,
        },

        {
          identifier: "Suppliers",
          label: "Suppliers",
          activeTags: ["supplier-list"],
          url: () => "supplier-list",
          translationFieldName: "Suppliers",
          hide: () => false,
        },
      ],
    },

    {
      identifier: "EQUIPMENT",
      position: 6,
      url: () => "equipment",
      icon: <EquipmentIcon className="app-nav-icon" />,
      activeTags: ["equipment", "equipment-details"],
      label: "Equipment",
      translationFieldName: "Equipment",
      hide: () => false,
      mobileOnly: false,
    },

    {
      identifier: "CONTACTS",
      position: 7,
      url: () => "company-list",
      icon: <CommercialIcon className="app-nav-icon" />,
      activeTags: ["contact-list", "company-list", "sales-pipeline"],
      label: "Commercial",
      translationFieldName: "Commercial",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "CONTACTS",
          label: "Contacts",
          activeTags: ["company-list"],
          url: () => "company-list",
          translationFieldName: "Contacts",
          hide: () => false,
        },
        {
          identifier: "QUOTES",
          label: "Quotations",
          activeTags: ["quote"],
          url: () => "quote",
          translationFieldName: "Quotation",
          hide: () => false,
        },
        {
          identifier: "PROJECT",
          label: "Sales PipeLine",
          activeTags: ["sales-pipeline"],
          url: () => "sales-pipeline",
          translationFieldName: "Sales Pipeline",
          hide: () => false,
        },
      ],
    },

    {
      identifier: "PROJECT_PARFORMA",
      position: 8,
      url: () => "proforma",
      icon: <InvoiceBlackIcon className="app-nav-icon" />,
      activeTags: ["proforma", "invoices", "payroll"],
      label: "Finance",
      translationFieldName: "Finance",
      hide: () => false,
      mobileOnly: false,
      bottom: false,
      children: [
        {
          identifier: "PROJECT_PARFORMA",
          label: "Proformas",
          activeTags: ["proforma"],
          url: () => "proforma",
          translationFieldName: "Proforma",
          hide: () =>
            window.localStorage.getItem("companyid") ==
              "28830f30-b321-4662-a576-f23451677742" ||
            window.localStorage.getItem("hasPlus") == "true",
        },
        {
          identifier: "PROJECT_INVOICE",
          label: "Invoices",
          activeTags: ["invoices"],
          url: () => "invoices",
          translationFieldName: "Invoice",
          hide: () => false,
        },
        // {
        //   identifier: "Expences",
        //   label: "Expences",
        //   activeTags: ["project/expences"],
        //   url: () => "project/expences",
        //   translationFieldName: "project",
        //   hide: () => false,
        // },
        // {
        //   identifier: "PROJECT",
        //   label: "Expences",
        //   activeTags: ["project"],
        //   url: () => "project",
        //   translationFieldName: "project",
        //   hide: () => false,
        // },
        {
          identifier: "BOOKKEEPING",
          label: "Bookkeeping",
          activeTags: ["bookkeeping"],
          url: () => "bookkeeping",
          translationFieldName: "Bookkeeping",
          // hide: () => false,
          // hide: () => packageId !== process.env.REACT_APP_IS_PREMIUM ? true : false,
          hide: () =>
            getAppSideNavOptions?.[0]?.packageId ===
              process.env.REACT_APP_IS_PREMIUM ||
            getAppSideNavOptions?.[0]?.packageId ===
              process.env.REACT_APP_IS_PLUS
              ? false
              : true,
          mobileOnly: false,
          bottom: false,
        },
        {
          identifier: "PAYROLL",
          label: "Payroll",
          activeTags: ["payroll"],
          url: () => "payroll",
          translationFieldName: "Payroll",
          // hide: () => false,
          hide: () => isRole([ROLES.USER, ROLES.VIEWER]),
          mobileOnly: false,
        },
        {
          identifier: "OCR",
          // position: 10,
          url: () => "ocr",
          icon: <OCRIcon className="app-nav-icon" />,
          activeTags: ["ocr", "ocr-add"],
          label: "OCR",
          translationFieldName: "Ocr",
          hide: () => false,
          mobileOnly: false,
        },
      ],
    },

    {
      identifier: "DEFAULT",
      position: 9,
      url: () => "my-task",
      icon: <TaskIcon className="app-nav-icon" />,
      activeTags: ["my-task"],
      label: "My Tasks",
      translationFieldName: "My Tasks",
      hide: () => false,
      mobileOnly: true,
      bottom: false,
    },

    {
      identifier: "BI_Dashboard",
      position: 10,
      url: () => "dashboard",
      icon: <DashboardIcon className="app-nav-icon" />,
      activeTags: ["dashboard"],
      label: "Insights",
      translationFieldName: "Dash Board",
      hide: () => isRole([ROLES.USER, ROLES.VIEWER, ROLES.MANAGER]),
      mobileOnly: false,
      bottom: false,
    },

    {
      identifier: "Spire_AI",
      position: 11,
      url: () => "Spire-AI",
      icon: <AIicon className="app-nav-icon" />,
      activeTags: ["Spire-AI"],
      label: "AI Drive",
      translationFieldName: "Spire_AI",
      // hide: () => isRole([ROLES.USER, ROLES.VIEWER, ROLES.MANAGER]),
      hide: () => false,
      mobileOnly: false,
      bottom: false,
    },

    // {
    //   identifier: "ACTIVITY",
    //   position: 10,
    //   url: () => "activity",
    //   icon: <DashboardIcon className="app-nav-icon" />,
    //   activeTags: ["activity"],
    //   label: "Activity",
    //   translationFieldName: "activity",
    //   hide: () => isRole([ROLES.USER, ROLES.VIEWER, ROLES.MANAGER]),
    //   mobileOnly: false,
    //   bottom: false,
    // },

    {
      identifier: "SETTING",
      position: 16,
      url: (isBasic) => (isBasic ? "settings-language" : "settings"),
      icon: <SettingIcon className="app-nav-icon" />,
      activeTags: [
        "settings",
        "settings-language",
        "my-plan",
        "settings-planboard",
        "invoices-settings",
        "workflow-automation",
        "add-workflow-automation",
        "update-workflow-automation",
        "form-poc",
        "form-builder",
        "spire-connect",
        "template-builder",
        "invoice-builder",
        "stock-builder",
        "quote-builder",
        "email-builder",
      ],
      label: "Settings",
      translationFieldName: "Settings",
      hide: () => isRole([ROLES.USER, ROLES.VIEWER]),
      mobileOnly: false,
      bottom: true,
    },
  ];
  // new sideBar end

  const [accessModules, setAccessModules] = useState([]);
  const [bookkeeping, setBookkeeping] = useState("");
  const [bookkeeping22, setBookkeeping22] = useState("");

  useEffect(() => {
    fetchScreenTranslations("Facebook").then((res) => {
      setFetchTranslationDatas(res);
    });
    dispatch(getAppSideBarOptions());
  }, []);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const hasPackagePlus =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.some(
          (x) =>
            x.packageName.toUpperCase() == "PLUS" ||
            x.packageId == process.env.REACT_APP_IS_PLUS,
        );
      window.localStorage.setItem("hasPlus", hasPackagePlus);
      setIsPlusMember(hasPackagePlus);
      const isBasicPlan =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.every(
          (x) =>
            x.packageName.toUpperCase() == "BASIC" &&
            x.packageId == process.env.REACT_APP_IS_BASIC,
        );
      setIsBasicMember(isBasicPlan);
      const modules = [];
      for (let index = 0; index < getAppSideNavOptions.length; index++) {
        const element = getAppSideNavOptions[index];
        let localElement = _SideNavOptions.find(
          (x) => x.identifier == element.identifier && x.hide() == false,
        );
        if (localElement) {
          if (localElement.children) {
            if (hasPackagePlus) {
              localElement.children = [];
            } else {
              let filterdChildren = localElement.children.filter(
                (x) =>
                  !x.hide() &&
                  getAppSideNavOptions &&
                  Array.isArray(getAppSideNavOptions) &&
                  getAppSideNavOptions.some(
                    (y) => y.identifier == x.identifier,
                  ),
              );
              localElement.children = filterdChildren;
            }
          }
          modules.push(localElement);
        }
      }
      let allDefaultOptions = _SideNavOptions.filter(
        (x) => x.identifier == "DEFAULT" && x.hide() == false,
      );
      if (allDefaultOptions && allDefaultOptions.length > 0) {
        modules.push(...allDefaultOptions);
      }
      setAccessModules([...modules.sort((a, b) => a.position - b.position)]);
      const identifier =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions?.find((item) => item?.identifier === "QUOTES");
      // localStorage.setItem("packageName", identifier?.packageName);
      // localStorage.setItem("packageId", identifier?.packageId);
    }
  }, [getAppSideNavOptions]);

  const getTranslateLabel = (key) => fetchTranslationDatas?.[key] || null;

  const handleMobileSidebarItemClick = (url) => {
    if (url) {
      history.push("/" + url);
    }
    document.body.classList.remove("mobile-sidebar-open");
  };

  const getSelectedNavItem = useMemo(() => {
    const currentPath = location.pathname.split("/")[1] || "";
    const filtered = accessModules.find((x) =>
      x.activeTags.includes(currentPath),
    );
    return filtered ? filtered.url() : null;
  }, [location, accessModules]);

  const getSelectedNavItem2 = useMemo(() => {
    const currentPath = location.pathname.split("/")[1] || "";
    const filtered = accessModules.find((x) =>
      x.activeTags.includes(currentPath),
    );
    return currentPath;
  }, [location, accessModules]);

  const RenderMobileNavItem = ({ item }) => {
    const hasChildren = Boolean(item.children);
    const [open, setOpen] = useState(false);

    const handleMenuClick = () => {
      if (hasChildren) {
        setOpen((p) => !p);
      } else {
        handleMobileSidebarItemClick(item.url(isBasicMember));
      }
    };

    return (
      <>
        <div
          className="mobile-sidebar-navitem"
          onClick={() => handleMenuClick()}
        >
          <div className="d-flex align-items-center justify-content-between">
            {getTranslateLabel(item.translationFieldName) || item.label}
            {hasChildren && (
              <div>{open ? <AiFillCaretUp /> : <AiFillCaretDown />}</div>
            )}
          </div>
        </div>
        {hasChildren && open && (
          <div className="mobile-sidebar-nav">
            {item.children.map((sub, subIndex) => {
              return (
                <div
                  className="mobile-sidebar-navitem"
                  key={`mobile-sidebar-sub-navitem-${subIndex}`}
                  onClick={() =>
                    handleMobileSidebarItemClick(sub.url(isBasicMember))
                  }
                >
                  {getTranslateLabel(sub.translationFieldName) || sub.label}
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  const [openParent, setOpenParent] = useState(null);

  return (
    <div className="overflow-visible">
      <div id="mobile-sidebar">
        <div className="mobile-sidebar-container">
          <div className="mobile-sidebar-actions">
            <AiOutlineCloseCircle
              size={25.54}
              color="#333333"
              onClick={() => {
                handleMobileSidebarItemClick();
              }}
            />
            <img
              className="app-logo-small"
              src={FetchCompanyThemRes.data[0]?.companylogo}
              alt="logo"
            />
          </div>
          <div className="mobile-sidebar-nav">
            {accessModules.map((item, index) => (
              <RenderMobileNavItem
                item={item}
                key={`mobile-menu-containe-${index}`}
              />
            ))}
          </div>
        </div>
      </div>
      <SideNav
        className="app-sidenav"
        onSelect={(selected) => {
          const to = "/" + selected;
          history.push(to);
        }}
        expanded={isSideNavOpen}
        onToggle={(expanded) => {
          setSideNavOpen(expanded);
        }}
      >
        <div className="app-sidebar-logo">
          <Link to="/planboard">
            {isSideNavOpen === true ? (
              <img
                className="app-logo"
                src={FetchCompanyThemRes.data[0]?.logowithtitle}
                alt="logo"
              />
            ) : (
              <img
                className="app-logo-small"
                src={FetchCompanyThemRes.data[0]?.companylogo}
                alt="logo"
              />
            )}
          </Link>
        </div>
        <SideNav.Nav
          className="app-sidenav-nav clearfix"
          selected={getSelectedNavItem2}
        >
          {!isBasicMember && (
            <div
              className="position-absolute"
              style={{
                right: -9,
                top: 30,
                zIndex: 2,
                cursor: "pointer",
                width: 20,
                height: 20,
              }}
              onClick={() => setSideNavOpen((prev) => !prev)}
            >
              {isSideNavOpen ? (
                <BsArrowLeftCircle color="#333333" size={20} />
              ) : (
                <BsArrowRightCircle color="#333333" size={20} />
              )}
            </div>
          )}
          {accessModules
            .filter((x) => !x.bottom && !x.mobileOnly)
            .map((item, index) => {
              if (
                roleAccess === ROLES.VIEWER &&
                item.identifier === "BOOKKEEPING"
              ) {
                return null;
              }

              return (
                <NavItem
                  eventKey={item.url(isBasicMember)}
                  key={`nav-index-${index}`}
                  navitemClassName="app-nav-item"
                  onClick={() => {
                    dispatch(Bookkeeping_Props(bookkeeping));
                    setBookkeeping("ascBook");
                    setBookkeeping22("ascBook22");
                    window.localStorage.setItem("redrectValue", true);
                    // window.localStorage.removeItem("activeTab");
                    handleParentClick(item);
                    // Toggle open parent
                    setOpenParent((prev) =>
                      prev === item.label ? null : item.label,
                    );
                  }}
                >
                  <NavIcon>
                    <div className="app-nav-icon-container">{item.icon}</div>
                  </NavIcon>

                  <div className="app-nav-icon-hitbox" />

                  <NavText>
                    <div className="app-nav-text">
                      {getTranslateLabel(item.translationFieldName) ||
                        item.label}
                    </div>
                  </NavText>

                  {/* parent menu nav icons start */}
                  {isSideNavOpen &&
                    item.children &&
                    item.children.length > 0 && (
                      <div
                        style={{
                          color: "black",
                          fontSize: "18px",
                          fontWeight: "700",
                          position: "absolute",
                          right: "10px",
                          top: "1px",
                        }}
                      >
                        <span>
                          {openParent === item.label ? (
                            <span
                              style={{
                                display: "block",
                                transform:
                                  openParent === item.label
                                    ? "rotate(90deg)"
                                    : "none",
                              }}
                            >
                              {">"}
                            </span>
                          ) : (
                            <span>{">"}</span>
                          )}
                        </span>
                      </div>
                    )}
                  {/* parent menu nav icons end */}

                  {/* sub menu start below */}
                  {isSideNavOpen &&
                    item.children &&
                    item.children
                      .filter(
                        (subItem) =>
                          !(
                            roleAccess === ROLES.VIEWER &&
                            (subItem.identifier === "PROJECT_PARFORMA" ||
                              subItem.identifier === "PROJECT_INVOICE")
                          ),
                      )
                      .map((subItem, subIndex) => (
                        <NavItem
                          eventKey={subItem.url()}
                          key={`sub-nav-index-${subIndex}`}
                          navitemClassName="app-sub-nav-item"
                          onClick={() => {
                            if (subItem.label === "Stock Levels") {
                              localStorage.setItem("openStockLevels", "true");
                            }
                          }}
                        >
                          <NavText>
                            <div className="app-sub-nav-text">
                              {getTranslateLabel(
                                subItem.translationFieldName,
                              ) || subItem.label}
                            </div>
                          </NavText>
                        </NavItem>
                      ))}
                </NavItem>
              );
            })}

          {accessModules
            .filter((x) => x.bottom && !x.mobileOnly)
            .map((item, index) => {
              return (
                <NavItem
                  eventKey={item.url(isBasicMember)}
                  key={`nav-bottom-index-${index}`}
                  navitemClassName={
                    index == 0
                      ? "app-nav-item app-nav-bottom-items"
                      : "app-nav-item"
                  }
                >
                  <NavIcon>
                    <div className="app-nav-icon-container">{item.icon}</div>
                  </NavIcon>
                  <NavText>
                    <div className="app-nav-text">
                      {getTranslateLabel(item.translationFieldName) ||
                        item.label}
                    </div>
                  </NavText>
                </NavItem>
              );
            })}
        </SideNav.Nav>
      </SideNav>
      <div id="main-content">
        <Router />
      </div>
    </div>
  );
};

export default Sidebar;
